import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Container, Typography, Button } from '@mui/material';

// Pages
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';

// Admin Pages
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import TermsPage from './pages/admin/TermsPage';
import LocationsPage from './pages/admin/LocationsPage';
import RoomsPage from './pages/admin/RoomsPage';
import InstrumentsPage from './pages/admin/InstrumentsPage';
import LessonTypesPage from './pages/admin/LessonTypesPage';
import DurationsPage from './pages/admin/DurationsPage';
import AgeGroupsPage from './pages/admin/AgeGroupsPage';
import ProgramLevelsPage from './pages/admin/ProgramLevelsPage';
import StreamsPage from './pages/admin/StreamsPage';
import TeachersPage from './pages/admin/TeachersPage';
import FamiliesPage from './pages/admin/ParentsPage';
import StudentsPage from './pages/admin/StudentsPage';
import SettlingInPage from './pages/admin/SettlingInPage';
import MeetAndGreetPage from './pages/admin/MeetAndGreetPage';
import EnquiriesPage from './pages/admin/EnquiriesPage';
import EventsPage from './pages/admin/EventsPage';
import EventEditorPage from './pages/admin/EventEditorPage';
import EventPricingStructuresPage from './pages/admin/EventPricingStructuresPage';
import AdminEventDetailPage from './pages/admin/EventDetailPage';
import SaveTheDatesPage from './pages/admin/SaveTheDatesPage';
import PermissionSlipsPage from './pages/admin/PermissionSlipsPage';
import PermissionSlipEditorPage from './pages/admin/PermissionSlipEditorPage';
import SaveTheDateEditorPage from './pages/admin/SaveTheDateEditorPage';
import NewStudentsPage from './pages/admin/NewStudentsPage';
import ExtraLessonRequestsPage from './pages/admin/ExtraLessonRequestsPage';
import LessonsPage from './pages/admin/LessonsPage';
import LessonDetailPage from './pages/admin/LessonDetailPage';
import CalendarPage from './pages/admin/CalendarPage';
import InvoicesPage from './pages/admin/InvoicesPage';
import InvoiceDetailPage from './pages/admin/InvoiceDetailPage';
import GoogleDrivePage from './pages/admin/GoogleDrivePage';
import GoogleDriveFilesPage from './pages/admin/GoogleDriveFilesPage';
import PricingPage from './pages/admin/PricingPage';
import PricingConfigPage from './pages/admin/PricingConfigPage';
import CustomDiscountsPage from './components/admin/discounts/CustomDiscountsPage';
import SubscriptionsPage from './pages/admin/SubscriptionsPage';
import ProductsPage from './pages/admin/ProductsPage';
import AbsenceManagementPage from './pages/admin/AbsenceManagementPage';
import AdminHybridPreBookingPage from './pages/admin/AdminHybridPreBookingPage';
import SecurityAuditPage from './pages/admin/SecurityAuditPage';
import XeroIntegrationPage from './pages/admin/XeroIntegrationPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import EmailSettingsPage from './pages/admin/EmailSettingsPage';
import SmsSettingsPage from './pages/admin/SmsSettingsPage';
import SystemEmailsPage from './pages/admin/SystemEmailsPage';
import NewslettersPage from './pages/admin/NewslettersPage';
import NewsletterEditorPage from './pages/admin/NewsletterEditorPage';
import NewsletterPreviewPage from './pages/admin/NewsletterPreviewPage';
import NewsletterAnalyticsPage from './pages/admin/NewsletterAnalyticsPage';
import CustomEmailsPage from './pages/admin/CustomEmailsPage';
import CustomEmailEditorPage from './pages/admin/CustomEmailEditorPage';
import EmailSequencesPage from './pages/admin/EmailSequencesPage';
import EmailSequenceEditorPage from './pages/admin/EmailSequenceEditorPage';
import CustomEmailAnalyticsPage from './pages/admin/CustomEmailAnalyticsPage';
import CustomSmsPage from './pages/admin/CustomSmsPage';
import CustomSmsEditorPage from './pages/admin/CustomSmsEditorPage';
import CustomSmsAnalyticsPage from './pages/admin/CustomSmsAnalyticsPage';
import AdminIntegrationsPage from './pages/admin/AdminIntegrationsPage';
import AchievementDefinitionsPage from './pages/admin/AchievementDefinitionsPage';
import PieceLibraryPage from './pages/admin/PieceLibraryPage';
import StudentProgressPage from './pages/admin/StudentProgressPage';
import LeaderboardPage from './pages/admin/LeaderboardPage';
import ImportExportPage from './pages/admin/ImportExportPage';
import RolesPage from './pages/admin/RolesPage';
import ReportsOverviewPage from './pages/admin/reports/ReportsOverviewPage';
import AttendanceReportPage from './pages/admin/reports/AttendanceReportPage';
import RevenueReportPage from './pages/admin/reports/RevenueReportPage';
import OutstandingInvoicesPage from './pages/admin/reports/OutstandingInvoicesPage';
import StudentProgressReportPage from './pages/admin/reports/StudentProgressReportPage';
import TeacherPerformancePage from './pages/admin/reports/TeacherPerformancePage';
import HybridBookingAnalyticsPage from './pages/admin/reports/HybridBookingAnalyticsPage';
import EnrollmentAnalyticsPage from './pages/admin/reports/EnrollmentAnalyticsPage';
import OperationalEfficiencyPage from './pages/admin/reports/OperationalEfficiencyPage';
import EmailLogReportPage from './pages/admin/reports/EmailLogReportPage';
import RetroEditsReportPage from './pages/admin/reports/RetroEditsReportPage';
import FamilyCreditReportPage from './pages/admin/reports/FamilyCreditReportPage';
import RegistrationFeesNotAppliedPage from './pages/admin/reports/RegistrationFeesNotAppliedPage';
import ReportSettingsPage from './pages/admin/reports/ReportSettingsPage';

// Teacher Pages
import TeacherDashboardPage from './pages/teacher/TeacherDashboardPage';
import NotesAttendancePage from './pages/teacher/NotesAttendancePage';
import TeacherFilesPage from './pages/teacher/FilesPage';
import CalendarIntegrationPage from './pages/teacher/CalendarIntegrationPage';
import TeacherMeetAndGreetPage from './pages/teacher/TeacherMeetAndGreetPage';
import TeacherMeetAndGreetsListPage from './pages/teacher/TeacherMeetAndGreetsListPage';
import TeacherNotificationPreferencesPage from './pages/teacher/TeacherNotificationPreferencesPage';

// Parent Pages
import ParentDashboardPage from './pages/parent/ParentDashboardPage';
import BookingsPage from './pages/parent/BookingsPage';
import ParentInvoicesPage from './pages/parent/InvoicesPage';
import MySubscriptionsPage from './pages/parent/MySubscriptionsPage';
import ResourcesPage from './pages/parent/ResourcesPage';
import NotificationPreferencesPage from './pages/parent/NotificationPreferencesPage';
import OnboardingProgressPage from './pages/parent/OnboardingProgressPage';
import ContactInformationPage from './pages/parent/ContactInformationPage';
import ParentCalendarPage from './pages/parent/ParentCalendarPage';
import ParentEnrolmentsPage from './pages/parent/ParentEnrolmentsPage';
import ReportAbsencePage from './pages/parent/ReportAbsencePage';
import AbsenceHistoryPage from './pages/parent/AbsenceHistoryPage';
import HybridBookingPage from './pages/parent/HybridBookingPage';
import ParentEventsPage from './pages/parent/ParentEventsPage';
import ParentPermissionSlipsPage from './pages/parent/ParentPermissionSlipsPage';
import ParentPermissionSlipDetailPage from './pages/parent/ParentPermissionSlipDetailPage';
import ParentEventDetailPage from './pages/parent/ParentEventDetailPage';

// Portal Pages (Parent Newsletter View)
import NewslettersPortalPage from './pages/portal/NewslettersPortalPage';
import NewsletterDetailPage from './pages/portal/NewsletterDetailPage';

// Student Pages
import StudentDashboardPage from './pages/student/StudentDashboardPage';

// Shared Pages
import MessagesPage from './pages/shared/MessagesPage';

// Settings Pages (shared across roles)
import AccountSettingsPage from './pages/settings/AccountSettingsPage';

// Public Pages
import LandingPage from './pages/LandingPage';
import SchoolsDirectoryPage from './pages/SchoolsDirectoryPage';
import SchoolLoginPage from './pages/SchoolLoginPage';
import MeetAndGreetBookingPage from './pages/public/MeetAndGreetBookingPage';
import MeetAndGreetVerifyPage from './pages/public/MeetAndGreetVerifyPage';
import EnquiryFormPage from './pages/public/EnquiryFormPage';
import PublicEventsListPage from './pages/public/PublicEventsListPage';
import PublicEventDetailPage from './pages/public/PublicEventDetailPage';
import PublicPermissionSlipPage from './pages/public/PublicPermissionSlipPage';
import EmailUnsubscribePage from './pages/public/EmailUnsubscribePage';
import AcceptInvitationPage from './pages/public/AcceptInvitationPage';
import RegistrationPage from './pages/public/RegistrationPage';
import LegalPage from './pages/public/LegalPage';
import WaitlistPage from './pages/public/WaitlistPage';
import SchoolProfileFallback from './components/public/SchoolProfileFallback';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import ErrorBoundary from './components/common/ErrorBoundary';
import { TenantProvider } from './contexts/TenantContext';

/**
 * A route-scoped ErrorBoundary that RESETS when the route changes.
 *
 * ⚠️ The `key` is the whole point. Every sibling leaf route renders its boundary
 * at the identical slot inside the parent's `<Outlet/>`, so React reconciles by
 * position and REUSES the same ErrorBoundary instance across a navigation —
 * `hasError: true` survives, and the fallback keeps rendering over whatever page
 * the admin clicked next. Measured 2026-09-15 with a MemoryRouter probe:
 * navigating from a throwing route to a healthy sibling gave
 * `stillBroken=true healthy=false`. Keying on pathname forces a fresh instance,
 * so one broken page stays one broken page instead of wedging the whole area.
 */
function RouteBoundary({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}

// Placeholder pages
const NotFound = () => (
  <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
    <Typography variant="h1" color="primary" sx={{ fontSize: '6rem', fontWeight: 'bold' }}>
      404
    </Typography>
    <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
      Page not found
    </Typography>
    <Button variant="contained" href="/">
      Go Home
    </Button>
  </Container>
);

function App() {
  return (
    <Routes>
      {/* PUBLIC ROOT ROUTES (no tenant context) */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/schools" element={<SchoolsDirectoryPage />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/legal/:type" element={<LegalPage />} />

      {/* SCHOOL-SPECIFIC ROUTES (with tenant context) */}
      <Route path="/:schoolSlug" element={<TenantProvider />}>
        {/* Public school routes (no auth) */}
        <Route path="login" element={<SchoolLoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="set-password/:token" element={<ResetPasswordPage />} />
        <Route path="meet-and-greet" element={<MeetAndGreetBookingPage />} />
        <Route path="meet-and-greet/verify/:token" element={<MeetAndGreetVerifyPage />} />
        <Route path="enquiry" element={<EnquiryFormPage />} />
        <Route path="events" element={<PublicEventsListPage />} />
        <Route path="events/:eventSlug" element={<PublicEventDetailPage />} />
        <Route path="register" element={<RegistrationPage />} />
        <Route path="invitation/accept/:token" element={<AcceptInvitationPage />} />
        {/* Magic-link signing. Unauthenticated by design — the token IS the credential. */}
        <Route path="permission-slips/sign/:token" element={<PublicPermissionSlipPage />} />
        {/* Email unsubscribe. Path MUST stay in step with `buildUnsubscribeUrl`
            (backend emailUnsubscribe.service.ts) — the permission-slip magic
            link shipped with a route/url mismatch and every link ever sent
            404'd. The :schoolSlug segment here is cosmetic; the token scopes. */}
        <Route path="unsubscribe/:token" element={<EmailUnsubscribePage />} />
        <Route path="legal/:type" element={<LegalPage />} />

        {/* Protected dashboard (role-agnostic) */}
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="admin"
          element={
            <ProtectedRoute requiredRole="ADMIN">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<RouteBoundary><AdminDashboardPage /></RouteBoundary>} />
          <Route path="terms" element={<RouteBoundary><TermsPage /></RouteBoundary>} />
          <Route path="locations" element={<RouteBoundary><LocationsPage /></RouteBoundary>} />
          <Route path="rooms" element={<RouteBoundary><RoomsPage /></RouteBoundary>} />
          <Route path="instruments" element={<RouteBoundary><InstrumentsPage /></RouteBoundary>} />
          <Route path="class-types" element={<RouteBoundary><LessonTypesPage /></RouteBoundary>} />
          <Route path="durations" element={<RouteBoundary><DurationsPage /></RouteBoundary>} />
          <Route path="age-groups" element={<RouteBoundary><AgeGroupsPage /></RouteBoundary>} />
          <Route path="program-levels" element={<RouteBoundary><ProgramLevelsPage /></RouteBoundary>} />
          <Route path="streams" element={<RouteBoundary><StreamsPage /></RouteBoundary>} />
          <Route path="teachers" element={<RouteBoundary><TeachersPage /></RouteBoundary>} />
          <Route path="families" element={<RouteBoundary><FamiliesPage /></RouteBoundary>} />
          <Route path="students" element={<RouteBoundary><StudentsPage /></RouteBoundary>} />
          <Route path="settling-in" element={<RouteBoundary><SettlingInPage /></RouteBoundary>} />
          <Route path="meet-and-greet" element={<RouteBoundary><MeetAndGreetPage /></RouteBoundary>} />
          <Route path="enquiries" element={<RouteBoundary><EnquiriesPage /></RouteBoundary>} />
          <Route path="events" element={<RouteBoundary><EventsPage /></RouteBoundary>} />
          <Route path="events/new" element={<RouteBoundary><EventEditorPage /></RouteBoundary>} />
          <Route path="events/:id" element={<RouteBoundary><AdminEventDetailPage /></RouteBoundary>} />
          <Route path="events/:id/edit" element={<RouteBoundary><EventEditorPage /></RouteBoundary>} />
          <Route path="save-the-dates" element={<RouteBoundary><SaveTheDatesPage /></RouteBoundary>} />
          <Route path="save-the-dates/new" element={<RouteBoundary><SaveTheDateEditorPage /></RouteBoundary>} />
          <Route path="save-the-dates/:id" element={<RouteBoundary><SaveTheDateEditorPage /></RouteBoundary>} />
          <Route path="event-pricing-structures" element={<RouteBoundary><EventPricingStructuresPage /></RouteBoundary>} />
          <Route path="permission-slips" element={<RouteBoundary><PermissionSlipsPage /></RouteBoundary>} />
          <Route path="permission-slips/new" element={<RouteBoundary><PermissionSlipEditorPage /></RouteBoundary>} />
          <Route path="permission-slips/:id" element={<RouteBoundary><PermissionSlipEditorPage /></RouteBoundary>} />
          <Route path="new-students" element={<RouteBoundary><NewStudentsPage /></RouteBoundary>} />
          <Route path="classes" element={<RouteBoundary><LessonsPage /></RouteBoundary>} />
          <Route path="classes/:id" element={<RouteBoundary><LessonDetailPage /></RouteBoundary>} />
          <Route path="calendar" element={<RouteBoundary><CalendarPage /></RouteBoundary>} />
          <Route path="extra-lessons" element={<RouteBoundary><ExtraLessonRequestsPage /></RouteBoundary>} />
          <Route path="invoices" element={<RouteBoundary><InvoicesPage /></RouteBoundary>} />
          <Route path="invoices/:id" element={<RouteBoundary><InvoiceDetailPage /></RouteBoundary>} />
          <Route path="payment-settings" element={<RouteBoundary><PricingPage /></RouteBoundary>} />
          <Route path="pricing-config" element={<RouteBoundary><PricingConfigPage /></RouteBoundary>} />
          <Route path="custom-discounts" element={<RouteBoundary><CustomDiscountsPage /></RouteBoundary>} />
          <Route path="subscriptions" element={<RouteBoundary><SubscriptionsPage /></RouteBoundary>} />
          <Route path="products" element={<RouteBoundary><ProductsPage /></RouteBoundary>} />
          <Route path="absences" element={<RouteBoundary><AbsenceManagementPage /></RouteBoundary>} />
          <Route path="hybrid-pre-booking" element={<RouteBoundary><AdminHybridPreBookingPage /></RouteBoundary>} />
          <Route path="google-drive" element={<RouteBoundary><GoogleDrivePage /></RouteBoundary>} />
          <Route path="google-drive/files" element={<RouteBoundary><GoogleDriveFilesPage /></RouteBoundary>} />
          <Route path="xero" element={<RouteBoundary><XeroIntegrationPage /></RouteBoundary>} />
          <Route path="integrations" element={<RouteBoundary><AdminIntegrationsPage /></RouteBoundary>} />
          <Route path="security-audit" element={<RouteBoundary><SecurityAuditPage /></RouteBoundary>} />
          <Route path="settings" element={<RouteBoundary><AdminSettingsPage /></RouteBoundary>} />
          <Route path="email-settings" element={<RouteBoundary><EmailSettingsPage /></RouteBoundary>} />
          <Route path="sms-settings" element={<RouteBoundary><SmsSettingsPage /></RouteBoundary>} />
          <Route path="system-emails" element={<RouteBoundary><SystemEmailsPage /></RouteBoundary>} />
          <Route path="import-export" element={<RouteBoundary><ImportExportPage /></RouteBoundary>} />
          <Route path="achievements" element={<RouteBoundary><AchievementDefinitionsPage /></RouteBoundary>} />
          <Route path="pieces" element={<RouteBoundary><PieceLibraryPage /></RouteBoundary>} />
          <Route path="student-progress" element={<RouteBoundary><StudentProgressPage /></RouteBoundary>} />
          <Route path="leaderboard" element={<RouteBoundary><LeaderboardPage /></RouteBoundary>} />
          <Route path="newsletters" element={<RouteBoundary><NewslettersPage /></RouteBoundary>} />
          <Route path="newsletters/new" element={<RouteBoundary><NewsletterEditorPage /></RouteBoundary>} />
          <Route path="newsletters/:id" element={<RouteBoundary><NewsletterEditorPage /></RouteBoundary>} />
          <Route path="newsletters/:id/preview" element={<RouteBoundary><NewsletterPreviewPage /></RouteBoundary>} />
          <Route path="newsletters/:id/analytics" element={<RouteBoundary><NewsletterAnalyticsPage /></RouteBoundary>} />
          <Route path="custom-emails" element={<RouteBoundary><CustomEmailsPage /></RouteBoundary>} />
          <Route path="custom-emails/new" element={<RouteBoundary><CustomEmailEditorPage /></RouteBoundary>} />
          <Route path="custom-emails/:id" element={<RouteBoundary><CustomEmailEditorPage /></RouteBoundary>} />
          <Route path="custom-emails/:id/analytics" element={<RouteBoundary><CustomEmailAnalyticsPage /></RouteBoundary>} />
          <Route path="email-sequences" element={<RouteBoundary><EmailSequencesPage /></RouteBoundary>} />
          <Route path="email-sequences/new" element={<RouteBoundary><EmailSequenceEditorPage /></RouteBoundary>} />
          <Route path="email-sequences/:id" element={<RouteBoundary><EmailSequenceEditorPage /></RouteBoundary>} />
          <Route path="custom-sms" element={<RouteBoundary><CustomSmsPage /></RouteBoundary>} />
          <Route path="custom-sms/new" element={<RouteBoundary><CustomSmsEditorPage /></RouteBoundary>} />
          <Route path="custom-sms/:id" element={<RouteBoundary><CustomSmsEditorPage /></RouteBoundary>} />
          <Route path="custom-sms/:id/analytics" element={<RouteBoundary><CustomSmsAnalyticsPage /></RouteBoundary>} />
          <Route path="messages" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="messages/:conversationId" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="account" element={<RouteBoundary><AccountSettingsPage /></RouteBoundary>} />
          <Route path="notifications" element={<RouteBoundary><TeacherNotificationPreferencesPage /></RouteBoundary>} />
          <Route path="reports" element={<RouteBoundary><ReportsOverviewPage /></RouteBoundary>} />
          <Route path="reports/attendance" element={<RouteBoundary><AttendanceReportPage /></RouteBoundary>} />
          <Route path="reports/revenue" element={<RouteBoundary><RevenueReportPage /></RouteBoundary>} />
          <Route path="reports/outstanding-invoices" element={<RouteBoundary><OutstandingInvoicesPage /></RouteBoundary>} />
          <Route path="reports/student-progress" element={<RouteBoundary><StudentProgressReportPage /></RouteBoundary>} />
          <Route path="reports/teacher-performance" element={<RouteBoundary><TeacherPerformancePage /></RouteBoundary>} />
          <Route path="reports/hybrid-booking" element={<RouteBoundary><HybridBookingAnalyticsPage /></RouteBoundary>} />
          <Route path="reports/enrollment" element={<RouteBoundary><EnrollmentAnalyticsPage /></RouteBoundary>} />
          <Route path="reports/operations" element={<RouteBoundary><OperationalEfficiencyPage /></RouteBoundary>} />
          {/* The Email Log moved from Reports to Communications; the old path keeps bookmarks working. */}
          <Route path="email-log" element={<RouteBoundary><EmailLogReportPage /></RouteBoundary>} />
          <Route path="reports/email-log" element={<RouteBoundary><Navigate to="../email-log" replace /></RouteBoundary>} />
          <Route path="reports/retro-edits" element={<RouteBoundary><RetroEditsReportPage /></RouteBoundary>} />
          <Route path="reports/family-credit" element={<RouteBoundary><FamilyCreditReportPage /></RouteBoundary>} />
          <Route path="reports/registration-fees" element={<RouteBoundary><RegistrationFeesNotAppliedPage /></RouteBoundary>} />
          <Route path="reports/settings" element={<RouteBoundary><ReportSettingsPage /></RouteBoundary>} />
          <Route path="roles" element={<RouteBoundary><RolesPage /></RouteBoundary>} />
        </Route>

        {/* Teacher Routes */}
        <Route
          path="teacher"
          element={
            <ProtectedRoute requiredRole="TEACHER">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<RouteBoundary><TeacherDashboardPage /></RouteBoundary>} />
          <Route path="teacher-tasks" element={<RouteBoundary><NotesAttendancePage /></RouteBoundary>} />
          <Route path="classes" element={<RouteBoundary><LessonsPage /></RouteBoundary>} />
          <Route path="classes/:id" element={<RouteBoundary><LessonDetailPage /></RouteBoundary>} />
          <Route path="calendar" element={<RouteBoundary><CalendarPage /></RouteBoundary>} />
          <Route path="files" element={<RouteBoundary><TeacherFilesPage /></RouteBoundary>} />
          <Route path="meet-and-greets" element={<RouteBoundary><TeacherMeetAndGreetsListPage /></RouteBoundary>} />
          <Route path="meet-and-greets/:id" element={<RouteBoundary><TeacherMeetAndGreetPage /></RouteBoundary>} />
          <Route path="calendar-integration" element={<RouteBoundary><CalendarIntegrationPage /></RouteBoundary>} />
          <Route path="notifications" element={<RouteBoundary><TeacherNotificationPreferencesPage /></RouteBoundary>} />
          <Route path="messages" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="messages/:conversationId" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="account" element={<RouteBoundary><AccountSettingsPage /></RouteBoundary>} />
        </Route>

        {/* Parent Routes */}
        <Route
          path="parent"
          element={
            <ProtectedRoute requiredRole="PARENT">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<RouteBoundary><ParentDashboardPage /></RouteBoundary>} />
          <Route path="bookings" element={<RouteBoundary><BookingsPage /></RouteBoundary>} />
          <Route path="invoices" element={<RouteBoundary><ParentInvoicesPage /></RouteBoundary>} />
          <Route path="subscriptions" element={<RouteBoundary><MySubscriptionsPage /></RouteBoundary>} />
          <Route path="resources" element={<RouteBoundary><ResourcesPage /></RouteBoundary>} />
          <Route path="notifications" element={<RouteBoundary><NotificationPreferencesPage /></RouteBoundary>} />
          <Route path="calendar" element={<RouteBoundary><ParentCalendarPage /></RouteBoundary>} />
          <Route path="enrolments" element={<RouteBoundary><ParentEnrolmentsPage /></RouteBoundary>} />
          <Route path="family-info" element={<RouteBoundary><ContactInformationPage /></RouteBoundary>} />
          <Route path="contacts" element={<RouteBoundary><ContactInformationPage /></RouteBoundary>} />
          <Route path="report-absence" element={<RouteBoundary><ReportAbsencePage /></RouteBoundary>} />
          <Route path="absences" element={<RouteBoundary><AbsenceHistoryPage /></RouteBoundary>} />
          <Route path="newsletters" element={<RouteBoundary><NewslettersPortalPage /></RouteBoundary>} />
          <Route path="newsletters/:slug" element={<RouteBoundary><NewsletterDetailPage /></RouteBoundary>} />
          <Route path="messages" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="messages/:conversationId" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="account" element={<RouteBoundary><AccountSettingsPage /></RouteBoundary>} />
          <Route path="onboarding" element={<RouteBoundary><OnboardingProgressPage /></RouteBoundary>} />
          <Route path="hybrid-booking/:lessonId" element={<RouteBoundary><HybridBookingPage /></RouteBoundary>} />
          <Route path="events" element={<RouteBoundary><ParentEventsPage /></RouteBoundary>} />
          <Route path="events/:id" element={<RouteBoundary><ParentEventDetailPage /></RouteBoundary>} />
          <Route path="permission-slips" element={<RouteBoundary><ParentPermissionSlipsPage /></RouteBoundary>} />
          <Route path="permission-slips/:id" element={<RouteBoundary><ParentPermissionSlipDetailPage /></RouteBoundary>} />
        </Route>

        {/* Student Routes */}
        <Route
          path="student"
          element={
            <ProtectedRoute requiredRole="STUDENT">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<RouteBoundary><StudentDashboardPage /></RouteBoundary>} />
          <Route path="messages" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="messages/:conversationId" element={<RouteBoundary><MessagesPage /></RouteBoundary>} />
          <Route path="account" element={<RouteBoundary><AccountSettingsPage /></RouteBoundary>} />
        </Route>

        {/* School landing page at the bare `/:schoolSlug` (MUST be after all named routes).
            The website builder that used to render a school's published home page here was
            removed 2026-09-16 (md/plan/website-removal.md); this is the profile card it fell
            back to for a school with no site — name, logo, and links to enquire / meet & greet
            / log in. `routing.ts` treats the bare slug as public for the same reason. */}
        <Route index element={<SchoolProfileFallback />} />

        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
